import React, { useMemo } from 'react'

import { ComboBox, ComboBoxChange, ComboBoxOption } from 'components/ComboBox'

import { useListCompanies } from '../../../hooks/useListCompanies'

type Props = {
  id?: string
  tenantId: string | null
  value: string
  onChange: (next: ComboBoxChange) => void
  isLocked?: boolean
  onClear?: () => void
  disabled?: boolean
}

export const CompanyComboBox: React.FC<Props> = ({
  id,
  tenantId,
  value,
  onChange,
  isLocked,
  onClear,
  disabled,
}) => {
  const { companies, isLoading } = useListCompanies(tenantId)

  const options = useMemo<ComboBoxOption[]>(
    () =>
      companies
        .filter((c) => c.companyName)
        .map((c) => ({ label: c.companyName as string, value: c.companyId })),
    [companies]
  )

  return (
    <ComboBox
      id={id}
      options={options}
      value={value}
      onChange={onChange}
      isLocked={isLocked}
      onClear={onClear}
      disabled={disabled}
      isLoading={isLoading}
    />
  )
}
